import styled from "@emotion/styled/macro";
import {ButtonBar} from "../../../components";
import {Spinner, Tooltip, Variables} from "@enter/core";
import {Field} from "formik";
import {TextField} from "@mui/material";
import {Icon} from "@mdi/react";

export const FormContainer = styled.section`
    width: 100%;
    margin: 0 auto;
    display: flex;
`;

export const Wrapper = styled.div`
    padding: 20px 0;
`;


export const SubCategoryItem = styled.div`
    overflow: auto;
    padding: 40px;

    padding: 0px 24px;
    flex-grow: 1;
`;


export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 18px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const DescriptionLabel = styled.label`
    font-size: 16px;
    color: ${Variables.Colors.n70};
    margin-top: 16px;
    margin-bottom: 8px;
`;


export const DescriptiveField = styled.input`
  flex-grow: 1;

  background-color: transparent;
  border: none;

  outline: none;
  flex-grow: 1;
  height: auto;
  font-size: 15px;

  min-height: 24px;
  resize: none;

  padding: 8px 16px;

  &:disabled {
    border-color: ${Variables.Colors.n15};
  }
`;

export const ActionButton = styled.div`
    display: inline-flex;
    border-left: 1px solid ${Variables.Colors.b300_l90};
`;

export const ActionTooltip = styled(Tooltip)`
    padding: 4px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
`;

export const ActionIcon = styled(Icon)`
    height: 18px;
    width: 18px;
    fill: ${Variables.Colors.b300_l62};
`;

export const FormField = styled(Field)`
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 32px;
    margin-bottom: 16px;
`;


export const ActionsContainer = styled.div`
    position: fixed;
    right: 50px;
    bottom: 50px;
`;

export const Pending = styled(Spinner)`
    background-color: transparent;
`;

export const HistoryEntryTime = styled.div`
    margin-left: 8px;
    font-size: 14px;
    color: ${Variables.Colors.n70};
`;


export const SideBySideInputGroup = styled.div`
    display: flex;
    flex-direction: row;
`;

export const SideBySideValue = styled.label`
  font-size: 18px;
  line-height: 1.22;
  color: ${Variables.Colors.n50};
  margin-top: 24px;
  margin-bottom: 8px;
  margin-left: 10px;
`;

export const ZeroPadFormField = styled(Field)`
    padding: 0 0px;
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const PaddedListItem = styled.li`
    padding-top: 5px;
`

export const ErrorWarningLabel = styled.span`
  color: ${Variables.Colors.r50}
`